import { render, staticRenderFns } from "./InscripcionesTabla.vue?vue&type=template&id=c2aa3548&"
import script from "./InscripcionesTabla.vue?vue&type=script&lang=js&"
export * from "./InscripcionesTabla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports